export const ACCOUNT_SETTINGS_FORM = 'ACCOUNT_SETTINGS_FORM';

export const IDENTITY_VERIFICATION_FORM = 'IDENTITY_VERIFICATION_FORM';

export const ADDITIONAL_IDENTITY_VERIFICATION_FORM = 'ADDITIONAL_IDENTITY_VERIFICATION_FORM';

export const VERIFICATION_TYPE = {
  CLASSIC: 'classic',
  AUTOMATED: 'automated',
  CYSEC: 'cysec',
};

export const DOCUMENT_PASSPORT = 'PASSPORT';
export const DOCUMENT_ID_CARD = 'ID_CARD';
export const DOCUMENT_DRIVERS = 'DRIVERS';
export const DOCUMENT_ID_DOC_PHOTO = 'ID_DOC_PHOTO';
export const DOCUMENT_UTILITY_BILL = 'UTILITY_BILL';
export const DOCUMENT_BANK_STATEMENT = 'DOCUMENT_BANK_STATEMENT';

export const DOCUMENT_FRONT_SIDE = 'FRONT_SIDE';
export const DOCUMENT_BACK_SIDE = 'BACK_SIDE';

export const DOCUMENT_TYPES = [
  { value: DOCUMENT_DRIVERS, label: 'Drivers Licence' },
  { value: DOCUMENT_ID_CARD, label: 'Government Issued Photo ID' },
  { value: DOCUMENT_PASSPORT, label: 'Passport' },
];

export const DOCUMENT_TYPES_ADDITIONAL_IDENTITY = [
  { value: DOCUMENT_ID_CARD, label: 'Government Issued Photo ID' },
  { value: DOCUMENT_DRIVERS, label: 'Drivers Licence' },
  { value: DOCUMENT_PASSPORT, label: 'Passport' },
  { value: DOCUMENT_UTILITY_BILL, label: 'Utility Bill' },
  { value: DOCUMENT_BANK_STATEMENT, label: 'Bank Statement' },
  { value: DOCUMENT_ID_DOC_PHOTO, label: 'Birth Certificate' },
];

export const DOCUMENT_SIDES = [
  { value: DOCUMENT_FRONT_SIDE, label: 'Front' },
  { value: DOCUMENT_BACK_SIDE, label: 'Back' },
];

export const REQUIRE_BACKSIDE = new Set([DOCUMENT_DRIVERS, DOCUMENT_ID_CARD]);

export const UPLOAD_BACKSIDE_MODAL = 'UPLOAD_BACKSIDE_MODAL';
export const VERIFICATION_AWAITING_MODAL = 'VERIFICATION_AWAITING_MODAL';

export const VERIFICATION_CHANGE_MFA_MODAL = 'VERIFICATION_CHANGE_MFA_MODAL';
export const VERIFICATION_MFA_SETUP_VERIFICATION_FORM = 'VERIFICATION_MFA_SETUP_VERIFICATION_FORM';
export const VERIFICATION_ENABLE_MFA_MODAL = 'VERIFICATION_ENABLE_MFA_MODAL';
